import { List, Stack, Text } from '@chakra-ui/react'
import { Rich, useT } from '~/i18n/use-t'

const GROUPS = [
  ['android', 'androidSteps'],
  ['iphone', 'iphoneSteps'],
  ['chrome', 'chromeSteps'],
  ['edge', 'edgeSteps'],
  ['firefox', 'firefoxSteps'],
  ['windows', 'windowsSteps'],
] as const

/**
 * The body of the FAQ entry `cameraAllow` (the entry's question is its title): how to allow the camera again after
 * pressing "Block" by mistake. `flow`: on the registration steps, "No camera at all?" points to "Email me a link to
 * continue" in the Help sheet (R110).
 */
export function CameraHelp({ flow = false }: { flow?: boolean }) {
  const { t, list } = useT()
  return (
    <Stack gap={5}>
      {GROUPS.map(([title, steps]) => (
        <Stack key={title} gap={1}>
          <Text fontWeight='bold' fontStyle='italic'>
            {t(`cameraHelp.${title}`)}
          </Text>
          <List.Root as='ol' ps={6} gap={1}>
            {list(`cameraHelp.${steps}`).map((s) => (
              <List.Item key={s}>{s}</List.Item>
            ))}
          </List.Root>
        </Stack>
      ))}
      <Text>
        <i>{t('cameraHelp.noCamera')}</i> <Rich k={flow ? 'cameraHelp.noCameraText' : 'cameraHelp.noCameraTextLogin'} />
      </Text>
    </Stack>
  )
}
